import styled from 'styled-components';

interface IProps {
    className?: string;
}

const BaseUseCurrentLocationIcon = ({ className }: IProps) => (
    <svg
        aria-hidden="true"
        className={className}
        fill="#AEACAC"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
    >
        <path
            clipRule="evenodd"
            d="m19.82 4.18-7.875 15.094v-6.468a.75.75 0 0 0-.75-.75h-6.47zm.203-1.797a1.183 1.183 0 0 1 1.594 1.595v.001l-8.94 17.136a1.184 1.184 0 0 1-2.232-.546v-7.013H3.43a1.183 1.183 0 0 1-.546-2.232l17.136-8.94z"
            fillRule="evenodd"
        />
    </svg>
);

export const UseCurrentLocationIcon = styled(BaseUseCurrentLocationIcon)``;
